import { action } from '../../../lib/api';

export const setContextMenuListener = (listener) => {
  action('SET_CONTEXT_MENU_LISTENER', listener);
};

export const setContextMenuTarget = (target) => {
  action('SET_CONTEXT_MENU_TARGET', target);
};
